import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import classNames from "classnames";
import "./tooltip.scss";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ maxwidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: maxwidth,
    wordBreak: "break-word",
  },
}));

export const CustomTooltip = ({
  text,
  position,
  maxWidth,
  className,
  ...props
}) => {
  return (
    <CustomWidthTooltip
      className={classNames("tooltip-wrapper", className)}
      title={text ? text : ""}
      placement={position}
      maxwidth={maxWidth}
      arrow
      {...props}
    >
      {props.children}
    </CustomWidthTooltip>
  );
};
